/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/snappers/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/snappers/plugin'
interact.use(plugin)